export default "__VITE_ASSET__6e8c73ae__"